import { jsx } from "@ecopages/jsx/jsx-runtime";
import { cx } from "@/lib/cx";
import "./tabs.script";
export function RuiTabList({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    class: cx("rui-tabs__list", className),
    role: "tablist",
    children
  });
}
export function RuiTab({
  id,
  children,
  class: className,
  disabled,
  selected,
  ...props
}) {
  return /* @__PURE__ */jsx("button", {
    ...props,
    type: "button",
    class: cx("rui-tabs__tab", className),
    role: "tab",
    id: `tab-${id}`,
    "data-tab-value": id,
    "aria-controls": `panel-${id}`,
    "aria-selected": selected ? "true" : "false",
    tabindex: selected ? 0 : -1,
    disabled,
    children
  });
}
export function RuiTabPanels({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    class: cx("rui-tabs__panels", className),
    children
  });
}
export function RuiTabPanel({
  id,
  children,
  class: className,
  selected,
  hidden,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    class: cx("rui-tabs__panel", className),
    role: "tabpanel",
    id: `panel-${id}`,
    "data-tab-value": id,
    "aria-labelledby": `tab-${id}`,
    tabindex: 0,
    hidden: selected === void 0 ? hidden : !selected,
    children
  });
}
export function RuiTabs({
  children,
  ...props
}) {
  return /* @__PURE__ */jsx("rui-tabs", {
    ...props,
    children
  });
}